import React, { useContext } from "react";

import classNames from "classnames";

import ComponentContext from "../../../contexts/ComponentContext";
import Markdown from "../../styles/Markdown";
import Map from "../Map/Map";
import MapLoader from "../MapLoader/MapLoader";

function MapWithTextArea() {
  const { text, mapPosition } = useContext(ComponentContext);

  const wrapperClassName = classNames("row flex-wrap-reverse", {
    "flex-row-reverse": mapPosition === "right",
  });

  return (
    <div className={wrapperClassName}>
      <div className="col-lg-6 mb-4 mb-lg-0  ">
        <div className="shadow-lg">
          <MapLoader hideText>
            <Map showText={false} withMarkers />
          </MapLoader>
        </div>
      </div>
      <div className="offset-lg-1 col-lg-3 me-auto">
        <Markdown>{text}</Markdown>
      </div>
    </div>
  );
}

export default MapWithTextArea;
